// extracted by mini-css-extract-plugin
module.exports = {"container":"top_limitation-module__container--ts8E4","link":"top_limitation-module__link--3ssT7"};